export function popups() {
    let mainWrap = $("body");
    // let parentElements = $("html, body");
    // let mainContainer = $(".main");
    // let scrollTop = void 0;
    // let windowWidth = window.innerWidth;

    // function lockBody() {
    //     if (window.pageYOffset) {
    //         scrollTop = window.pageYOffset;
    //         mainContainer.css({
    //             top: -scrollTop
    //         });
    //     }
    //     parentElements.css({
    //         height: "100%",
    //         overflow: "hidden"
    //     });
    // }
    //
    // function unlockBody() {
    //     parentElements.css({
    //         height: "",
    //         overflow: ""
    //     });
    //     mainContainer.css({
    //         top: ""
    //     });
    //     window.scrollTo(0, scrollTop);
    //     window.setTimeout(function () {
    //         scrollTop = null;
    //     }, 0);
    // }

    // $(document).ready(function () {
    //     //Show login popup if no access page
    //     if (mainWrap.hasClass('no_access_page user_no_loggin')) {
    //         $(window).scrollTop();
    //         if (windowWidth < 1200 && !/(android)/i.test(navigator.userAgent)) {
    //             lockBody();
    //         }
    //         $('#popup-login').addClass("active");
    //         mainWrap.addClass("no-scroll");
    //     }
    // });

    function createCookie(name, value, days) {
        let expires;

        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
    }

// function readCookie(name) {
//     let nameEQ = encodeURIComponent(name) + "=";
//     let ca = document.cookie.split(';');
//     for (let i = 0; i < ca.length; i++) {
//         let c = ca[i];
//         while (c.charAt(0) === ' ')
//             c = c.substring(1, c.length);
//         if (c.indexOf(nameEQ) === 0)
//             return decodeURIComponent(c.substring(nameEQ.length, c.length));
//     }
//     return null;
// }
// function eraseCookie(name) {
//     createCookie(name, "", -1);
// }
// eraseCookie('set_cookie_vote');

    $(window).on("load", function () {
        // let scrolled = 0;
        let slideNum = 0;
        // let isExistPopupLogin = $("#popup-login").length > 0;

        $(document).on("click", ".popup-link", function (event) {
            event.preventDefault();

            // scrolled = $(window).scrollTop();
            //
            // if (windowWidth < 1200 && !/(android)/i.test(navigator.userAgent)) {
            //     lockBody();
            // }

            if ($(this).attr("data-slide-num")) {
                let slideNum = parseInt($(this).attr("data-slide-num"));
                $(".product-popup-slider").slick("slickGoTo", parseInt(slideNum - 1));
            }

            if ($(this).attr("data-ticket")) {
                $("#form-waitlist .ticket-field").val($(this).attr("data-ticket"));
            }

            let popup = $($(this).attr("href"));
            let $time = ($(this).attr("data-coupon")) ? 0 : 500;
            setTimeout(function () {
                popup.addClass("active");
                mainWrap.addClass("no-scroll");
            }, $time);

            //Ajax load content - Hair formation popup
            if ($(this).attr("data-obj")) {
                let $hair_popup = $(".popup-hair-formation");

                let data = {
                    'action': 'get_hair_formation',
                    'obj': $(this).attr("data-obj"),
                    'column': $(this).attr("data-column"),
                    'row': $(this).attr("data-row"),
                };

                $.ajax({
                    url: ajax_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        popup.removeClass("active");
                    },
                    success: function (response) {
                        if (response['content']) {
                            $hair_popup.find('.ajax-popup-content').html(response['content']);

                            let $product_list = $hair_popup.find(".product-list");
                            $product_list.mCustomScrollbar({
                                theme: "my-theme",
                                axis: "x",
                            });

                            popup.addClass("active");
                        }
                    }
                });
            }

            //Ajax load content - Team popup
            if ($(this).attr("data-team")) {

                let data = {
                    'action': 'get_facilitator_info',
                    'team_id': parseInt($(this).attr("data-team"))
                };

                $.ajax({
                    url: ajax_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        popup.removeClass("active");
                    },
                    success: function (response) {
                        if (response) {
                            $('.popup-team .popup-content').append(response['content']);
                            initCustomScrollbar();
                            popup.addClass("active");
                        }
                    }
                });
            }

            //Ajax load content - Oceana video popup
            if ($(this).attr("data-video-oceana")) {
                let data = {
                    'action': 'get_video_oceana',
                    'oceana_video': $(this).attr("data-video-oceana")
                };

                $.ajax({
                    url: ajax_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        popup.removeClass("active");
                    },
                    success: function (response) {
                        if (response) {
                            $('.popup-video-oceana .ajax-popup-content').html(response['content']);
                            popup.addClass("active");
                        }
                    }
                });
            }

            //Ajax load content - Vimeo video popup
            if ($(this).attr("data-video-vimeo")) {
                let data = {
                    'action': 'get_video_oceana',
                    'oceana_video': $(this).attr("data-video-vimeo")
                };

                $.ajax({
                    url: ajax_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        popup.removeClass("active");
                    },
                    success: function (response) {
                        if (response) {
                            $('.popup-video-vimeo .ajax-popup-content').html(response['content']);
                            popup.addClass("active");
                        }
                    }
                });
            }

            //Ajax load content - Youtube video popup
            if ($(this).attr("data-video-youtube")) {
                let data = {
                    'action': 'get_video_youtube',
                    'youtube_video': $(this).attr("data-video-youtube")
                };

                $.ajax({
                    url: ajax_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        popup.removeClass("active");
                    },
                    success: function (response) {
                        if (response) {
                            $('.popup-video-youtube .ajax-popup-content').html(response['content']);
                            popup.addClass("active");
                        }
                    }
                });
            }

            //Ajax load content - Community popup
            if ($(this).attr("data-community")) {
                let data = {
                    'action': 'get_community_info',
                    'community_id': $(this).attr("data-community"),
                    'video_index': $(this).attr("data-index")
                };

                $.ajax({
                    url: ajax_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        popup.removeClass("active");
                    },
                    success: function (response) {
                        if (response) {
                            $('.popup-video-community .ajax-popup-content').html(response['content']);
                            popup.addClass("active");
                        }
                    }
                });
            }

            //Ajax load content - Brand campaign popup
            if ($(this).attr("data-brand-campaign")) {
                let data = {
                    'action': 'get_brand_campaign_info',
                    'brand_campaign_id': $(this).attr("data-brand-campaign"),
                    'video_index': $(this).attr("data-index")
                };

                $.ajax({
                    url: ajax_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        popup.removeClass("active");
                    },
                    success: function (response) {
                        if (response) {
                            $('.popup-video-brand-campaign .ajax-popup-content').html(response['content']);
                            popup.addClass("active");
                        }
                    }
                });
            }

            //Ajax load content - Video classes popup (Woo products, category Videos)
            if ($(this).attr("data-video")) {
                let $post_id = $(this).attr("data-video");
                let data = {
                    'action': 'get_full_video_classes',
                    'video_id': $post_id,
                    'trailer': $(this).attr("data-trailer")
                };

                $.ajax({
                    url: ajax_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        popup.removeClass("active");
                    },
                    success: function (response) {
                        if (response) {
                            $('.popup-video-classes .ajax-popup-content').html(response);
                            popup.addClass("active");

                            let video = $('.popup-video-classes').find('iframe');
                            if (video.length) {
                                let player = new Vimeo.Player(video);
                                player.on('ended', function (getAll) {
                                    console.log('viewed: 1');
                                    viewed_videos_by_user($post_id);
                                });

                            }
                        }
                    }
                });
            }

            //Ajax load content - Main banner: video slide
            if ($(this).attr("data-slide-video")) {
                let data = {
                    'action': 'get_full_video',
                    'video_id': $(this).attr("data-slide-video")
                };

                $.ajax({
                    url: ajax_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        popup.removeClass("active");
                    },
                    success: function (response) {
                        if (response) {
                            $('.popup-video-classes .ajax-popup-content').html(response);
                            popup.addClass("active");
                        }
                    }
                });
            }

            //Ajax load content - Coupon info
            if ($(this).attr("data-coupon")) {
                let data = {
                    'action': 'get_coupon_info',
                    'coupon': $(this).attr("data-coupon"),
                    'percentage_discount': $(this).attr("data-percentage"),
                    'description': $(this).attr("data-desc")
                };

                $.ajax({
                    url: ajax_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        popup.removeClass("active");
                        popup.find('.ajax-popup-content').html('');
                    },
                    success: function (response) {
                        if (response) {
                            popup.find('.ajax-popup-content').html(response);
                            popup.find('.button').on('click', function () {
                                setTimeout(function () {
                                    closePopup();
                                }, 350);
                            });

                            popup.addClass("active");
                        }
                    }
                });
            }

            //Ajax load content - Finalist info
            if ($(this).attr("data-finalist")) {
                let data = {
                    'action': 'get_finalist_info',
                    'post_id': $(this).attr("data-finalist")
                };

                $.ajax({
                    url: ajax_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        popup.removeClass("active");
                        popup.find('.ajax-popup-content').html('');
                    },
                    success: function (response) {
                        if (response) {
                            popup.find('.ajax-popup-content').html(response);

                            let portfolioSlider = popup.find('.portfolio-slider');
                            portfolioSlider.slick({
                                infinite: true,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                prevArrow: $(".popup .common-slider-controls .prev-arrow"),
                                nextArrow: $(".popup .common-slider-controls .next-arrow"),
                            });

                            competition_voting();

                            popup.addClass("active");
                        }
                    }
                });
            }

            //Add name Event product
            // if ($(this).attr("data-event-product")) {
            //     let $form = $('.popup-event-product form');
            //     if ($form.length) {
            //         $form.find('.wpcf7-form-control.product').val($(this).attr("data-event-product"));
            //     }
            // }

            //Ajax Docebo authorization
            // if ($(this).hasClass('docebo')) {
            //     let d_popup = $('.popup-docebo');
            //     let data = {
            //         'action': 'authorization_docebo'
            //     };
            //
            //     $.ajax({
            //         url: ajax_params.ajaxurl,
            //         data: data,
            //         type: 'POST',
            //         beforeSend: function () {
            //             d_popup.find('.form-wrap').html('<h3>Authorization...</h3>');
            //         },
            //         success: function (response) {
            //             if (response) {
            //                 d_popup.find('.form-wrap').html(response['content']);
            //
            //                 if (d_popup.find('a.docebo-link').length) {
            //                     let url = d_popup.find('a.docebo-link').attr('href');
            //                     closePopup();
            //                     window.open(url, '_blank');
            //                 }
            //             }
            //         }
            //     });
            // }

        }).on("click", ".popup-close", function () {
            closePopup();
        });

        function competition_voting() {
            let finalists = $('.holder-finalists');
            $('.btn-vote').on('click', function (e) {
                e.preventDefault();

                console.log('btn-vote');

                let _this = $(this),
                    $post_id = _this.attr('data-finalist');

                finalists.find('.button').hide();

                let data = {
                    'action': 'competition_voting',
                    'post_id': $post_id
                };

                $.ajax({
                    url: ajax_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                    },
                    success: function () {
                        createCookie("set_cookie_vote", "true", 1);
                        finalists.find('.btn-vote[data-finalist="' + $post_id + '"]').closest('.finalist').addClass('voted');

                        closePopup();
                    }
                });
            });
        }

        competition_voting();

        function closePopup() {
            if (mainWrap.hasClass('no_access_page user_no_loggin')) {
                window.location.href = window.location.origin;
            } else {
                $(".popup").removeClass("active");
                mainWrap.removeClass("no-scroll");
                window.location.hash = "";

                // $("html, body").scrollTop(scrolled);

                // if (windowWidth < 1200 && !/(android)/i.test(navigator.userAgent)) {
                //     unlockBody();
                // }

                if ($(".popup").hasClass('popup-team')) {
                    let $teamHeader = $(".popup-team .holder-team-title");
                    let $teamContent = $(".popup-team .holder-team-content");

                    if ($teamHeader.length) $teamHeader.remove();
                    if ($teamContent.length) $teamContent.remove();
                }

                if ($(".popup").hasClass('popup-video-oceana')) {
                    $('.popup-video-oceana .popup-content').remove();
                }

                if ($(".popup").hasClass('popup-video-vimeo')) {
                    $('.popup-video-vimeo .popup-content').remove();
                }

                if ($(".popup").hasClass('popup-video-youtube')) {
                    $('.popup-video-youtube .popup-content').remove();
                }

                if ($(".popup").hasClass('popup-video-community')) {
                    $('.popup-video-community .popup-content').remove();
                }

                if ($(".popup").hasClass('popup-video-brand-campaign')) {
                    $('.popup-video-brand-campaign .popup-content').remove();
                }

                if ($(".popup").hasClass('popup-video-classes')) {
                    $('.popup-video-classes .popup-content').remove();
                }

                if ($(".popup").hasClass('popup-hair-formation')) {
                    $('.popup-hair-formation .holder-popup-hair-formation').remove();
                }

                if ($(".popup").hasClass('popup-portfolio')) {
                    $('.popup-portfolio .ajax-popup-content').html('');
                }

                if ($(".popup").hasClass('popup-subscribers-news-events')) {
                    //Set cookie
                    createCookie("set_subscriber_news_events", "true", 30);
                }
            }
        }

        function popup_slider() {
            if ($(".product-popup-slider").length) {
                let popupSlider = $(".product-popup-slider");
                let curSlideNum = $(".cur-slide-num");
                let curSlideDesc = $(".cur-slide-desc");
                let totalSlideNum = $(".total-slide-num");

                // (function productPopupSlider() {
                popupSlider.on("init", function (event, slick) {
                    curSlideNum.text(parseInt(slick.currentSlide + 1));
                    totalSlideNum.text(slick.slideCount);

                    //Get slide description - Community popup
                    // if (curSlideDesc.length && $('.popup-community').length) {
                    //     let slide = popupSlider.find('.slick-slide');
                    //     let currentItem = slide[slick.currentSlide];
                    //     let slideDesc = $(currentItem).find('.slide').attr('data-slide-desc');
                    //     curSlideDesc.text(slideDesc);
                    // }
                });
                popupSlider.slick({
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: $(".popup .common-slider-controls .prev-arrow"),
                    nextArrow: $(".popup .common-slider-controls .next-arrow"),
                    initialSlide: slideNum
                });

                popupSlider.on("afterChange", function (event, slick, currentSlide) {
                    curSlideNum.text(parseInt(slick.currentSlide + 1));

                    //Get slide description - Gallery popup
                    if (curSlideDesc.length) {
                        let slide = popupSlider.find('.slick-slide');
                        let currentItem = slide[currentSlide];
                        let slideDesc = $(currentItem).find('.slide').attr('data-slide-desc');
                        curSlideDesc.text(slideDesc);
                    }

                    //Get slide image - Brand campaigns popup
                    if ($('#popup-gallery-brand-campaign').length) {
                        let slide = popupSlider.find('.slick-slide');
                        let currentItem = slide[slick.currentSlide];
                        let slideImg = $(currentItem).find('.slide').attr('data-image');

                        $('#popup-gallery-brand-campaign').find('a.btn-download').attr('href', slideImg);
                    }
                });
                // })();
            }
        }

        popup_slider();

        $(".popups").on("click", function (event) {
            if (!$(event.target).closest(".popup").length) {
                closePopup();
            }
        });

        $(".non-auth a:not(.header-logo)").on("click", function (event) {
            let $this = $(this);

            //Show registration popup
            if ($this.attr('href') == '#popup-reg') {
                event.preventDefault();
                // scrolled = $(window).scrollTop();
                mainWrap.addClass("no-scroll");
                $("#popup-login").addClass("active");

                $('#login_form').hide();
                $('#reg_form').show();
            }
        });

        //Viewed videos by user
        function viewed_videos_by_user($post_id) {
            let data = {
                'action': 'viewed_videos_by_user',
                'post_id': $post_id
            };

            $.ajax({
                url: ajax_params.ajaxurl,
                data: data,
                type: 'POST',
                beforeSend: function () {
                },
                success: function () {
                    console.log('updating viewed videos by user');
                }
            });
        }

        //Popup business summit
        function send_livestream_notifications($user) {
            let data = {
                'action': 'user_livestream_notifications',
                'data_user': $user
            };

            $.ajax({
                url: ajax_params.ajaxurl,
                data: data,
                type: 'POST',
                beforeSend: function () {
                },
                success: function () {
                    console.log('send livestream email');
                }
            });
        }

        let $btn_business_summit = $('.content-business-summit .popup-link');
        if ($btn_business_summit.length) {
            if (parseInt($btn_business_summit.attr('data-status'))) {
                $btn_business_summit.trigger('click');
            }
        }

        let $popup_business_summit = $('#popup-business-summit');
        let $register_business_summit = $popup_business_summit.find('.button-register');
        if ($register_business_summit.length) {
            $register_business_summit.on('click', function (e) {
                e.preventDefault();

                let _user = $(this).attr("data-user");
                let data = {
                    'action': 'user_livestream_registrations',
                    'data_user': _user
                };

                $.ajax({
                    url: ajax_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        // $register_business_summit.hide();
                    },
                    success: function () {
                        send_livestream_notifications(_user);
                        closePopup();
                    }
                });
            })
        }

        //Footer subscribe form
        $.validator.addMethod("requiredcountry", function (value, element, arg) {
            return arg != value;
        }, "this field is required");

        let footer_subscribe_form = $('#footer_subscribe_form');
        if (footer_subscribe_form.length > 0) {
            footer_subscribe_form.validate({
                ignore: [],
                rules: {
                    email: {},
                    subscriber_country: {
                        required: true,
                        requiredcountry: ""
                    }
                },
                submitHandler: function () {
                    let data = {
                        'action': 'subscribers_news_events',
                        'email': footer_subscribe_form.find('input[type="email"]').val(),
                        'country': footer_subscribe_form.find('#subscriber_country').find(":selected").text()
                    };

                    $.ajax({
                        url: ajax_params.ajaxurl,
                        data: data,
                        type: 'POST',
                        beforeSend: function () {
                            footer_subscribe_form.find('.status').removeClass('list-errors');
                            footer_subscribe_form.find('input[type="submit"]').attr('disabled', 'disabled');
                        },
                        success: function (res) {
                            if (res.status === false) {
                                footer_subscribe_form.find('.status').addClass('list-errors');
                            } else {
                                footer_subscribe_form[0].reset();
                                footer_subscribe_form.find('#subscriber_country').val('').trigger('change');
                            }

                            $('.status').html(res.error);
                            footer_subscribe_form.find('input[type="submit"]').removeAttr('disabled');
                        }
                    });
                    return false;
                }
            });
        }

        //Popup Subscribers for news and events
        let subscribers_news_events_popup = $('#popup-subscribers-news-events');
        let subscribers_news_events_form = subscribers_news_events_popup.find('form');
        if (subscribers_news_events_form.length > 0) {
            mainWrap.addClass("no-scroll");
            subscribers_news_events_popup.addClass("active");

            subscribers_news_events_form.validate({
                ignore: [],
                rules: {
                    email: {},
                    subscriber_country: {
                        required: true,
                        requiredcountry: ""
                    }
                },
                // errorPlacement: function (error, element) {
                // },
                submitHandler: function () {
                    let data = {
                        'action': 'subscribers_news_events',
                        'email': subscribers_news_events_form.find('input[type="email"]').val(),
                        'country': $('#subscriber_country').find(":selected").text()
                    };

                    $.ajax({
                        url: ajax_params.ajaxurl,
                        data: data,
                        type: 'POST',
                        beforeSend: function () {
                            subscribers_news_events_form.find('input[type="submit"]').attr('disabled', 'disabled');
                        },
                        success: function (res) {
                            $('.status').html(res.error);
                            subscribers_news_events_form.find('input[type="submit"]').removeAttr('disabled');

                            if (res.status === true) {
                                closePopup();
                            }
                        }
                    });
                    return false;
                }
            });
        }

        //Popup Event Products - Artist Lineup
        let $eventProduct = $(".popup-event-product .holder-list-items");
        if ($eventProduct.length) {

            $eventProduct.mCustomScrollbar({
                theme: "my-theme",
            });

            let $listItems = $eventProduct.find('.list-items > li');
            $listItems.each(function () {
                let $this = $(this);
                let $viewMore = $this.find('.view-more');

                if ($viewMore.length) {
                    $viewMore.click(function (e) {
                        e.preventDefault();

                        let $this = $(this);

                        $this.closest('.holder-text').toggleClass('full-text');
                        $this.text(function (i, text) {
                            return text === "view more" ? "hide" : "view more";
                        });
                    });
                }
            });
        }
    });

    window.addEventListener("resize", () => {
        if ($('.meet-the-team').length) {
            let $teamContent = $(".popup-team .holder-team-content");
            let $teamCol = $(".popup-team .team-col");

            if ($teamContent.hasClass("mCS_destroyed") && $teamCol.hasClass("mCS_destroyed")) return;

            if ($teamContent.hasClass("mCustomScrollbar")) $teamContent.mCustomScrollbar("destroy");
            if ($teamCol.hasClass("mCustomScrollbar")) $teamCol.mCustomScrollbar("destroy");

            if (window.innerWidth >= 1024) {
                $teamCol.mCustomScrollbar({
                    theme: "my-theme",
                });
            } else {
                $teamContent.mCustomScrollbar({
                    theme: "my-theme",
                });
            }
        }
    });
}

function initCustomScrollbar() {
    let $teamContent = $(".popup-team .holder-team-content");
    let $teamCol = $(".popup-team .team-col");


    if (window.innerWidth >= 1024) {
        $teamCol.mCustomScrollbar({
            theme: "my-theme",
        });
    } else {
        $teamContent.mCustomScrollbar({
            theme: "my-theme",
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/popups.js